(function() {
    'use strict';

    angular.module('caffeprint').controller('OrderDuplicateModalController', OrderDuplicateModalController);

    OrderDuplicateModalController.$inject = ['$uibModalInstance', 'order'];

    function OrderDuplicateModalController($uibModalInstance, order) {
        var self = this;

        self.order = order;
        self.ok = ok;
        self.cancel = cancel;

        function ok() {
            $uibModalInstance.close();
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
